const timer = setInterval(() => {
  const checkoutSection = document.querySelector('.bottom-section');

  if (checkoutSection) {
    clearInterval(timer);

    const gridContainerHTML = `
      <div class="op_add_grid" style="display: flex; flex-direction: row; padding-bottom: 10px; justify-content: space-around;">
        <!-- Free Returns or Exchange for 30 Days -->
        <div style="display: flex; flex-direction: column; align-items: center; text-align: center; justify-content: flex-start; padding-left: 15px;">
          <img src="https://cdn.shopify.com/s/files/1/0735/9656/7841/files/Screenshot_2025-01-14_194501.png?v=1736925813" alt="Free Returns or Exchange for 30 Days" style="width: 40px; height: 40px;">
          <span style="font-size: 11px; width: 95px;">Free Returns or Exchange</span>
        </div>
        <!-- Refunds within 24-48 hours -->
        <div style="display: flex; flex-direction: column; align-items: center; text-align: center; justify-content: flex-start; margin-top: 17px;">
          <img src="https://cdn.shopify.com/s/files/1/0735/9656/7841/files/Screenshot_2025-01-14_193847.png?v=1736925813" alt="Refunds within 24-48 hours" style="width: 50px; height: 25px">
          <span style="font-size: 11px; width: 95px;">Refunds within 24-48 hours</span>
        </div>
        <!-- 7-10 Days Shipping Policy -->
        <div style="display: flex; flex-direction: column; align-items: center; text-align: center; justify-content: flex-start; padding-left: 15px; margin-top: 12px;">
          <img src="https://cdn.shopify.com/s/files/1/0735/9656/7841/files/Screenshot_2025-01-14_193851.png?v=1736925813" alt="7-10 Days Shipping Policy" style="width: 30px; height: 30px; margin-right: 15px;">
          <span style="font-size: 11px; width: 95px;">7-10 Days Shipping Policy</span>
        </div>
        <!-- Secured Payments -->
        <div style="display: flex; flex-direction: column; align-items: center; text-align: center; justify-content: flex-start; margin-top: 7px;">
          <img src="https://cdn.shopify.com/s/files/1/0735/9656/7841/files/Screenshot_2025-01-14_194228.png?v=1736925813" alt="Secured Payments" style="width: 50px; height: 36px;">
          <span style="font-size: 11px; width: 90px;">Secured Payments</span>
        </div>
      </div>
    `;

    // Insert the grid container after the checkout section
    checkoutSection.insertAdjacentHTML('afterend', gridContainerHTML);
  }
}, 1000);

window.addEventListener('OpusCartChange', (event) => {
  console.log('Event received:', event);
  const data = event.detail;

  if (!data || typeof data.total_price === 'undefined') {
    console.error('Total price is missing in event detail.');
    return;
  }

  const totalPrice = data.total_price;
  console.log('Total Price:', totalPrice);

  const checkoutButton = document.getElementById('checkout2');
  if (checkoutButton) {
    console.log('Checkout button found:', checkoutButton);

    const previousSpan = checkoutButton.nextElementSibling;
    if (previousSpan && previousSpan.classList.contains('price-label')) {
      console.log('Removing existing price label:', previousSpan);
      previousSpan.remove();
    }

    checkoutButton.insertAdjacentHTML(
      'afterend',
      `<span class="price-label" style="margin-right: 10px; color: white">${totalPrice}₫</span>`
    );
    console.log('Price label updated.');
  } else {
    console.warn('Checkout button not found!');
  }

  console.log('Event data processed:', data);
});
